import { render, staticRenderFns } from "./OpcionaisDeVeiculos.vue?vue&type=template&id=691e6818&"
import script from "./OpcionaisDeVeiculos.vue?vue&type=script&lang=js&"
export * from "./OpcionaisDeVeiculos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports